import { MiddleOfficeButtonType } from '@shared/components/middle-office-button/enum';
import { MiddleOfficeButton } from '@shared/components/middle-office-button/model';

export const middleOfficeButtonConfig: { [key: string]: MiddleOfficeButton } = {
  [MiddleOfficeButtonType.EDIT_HERO]: {
    text: `Modifier l'image le fond`,
    endpoint: `/hero`,
  },
  [MiddleOfficeButtonType.EDIT_STORE_SCHEDULES]: {
    text: 'Modifier les horaires de la boutique',
    endpoint: `/hours`,
  },
  [MiddleOfficeButtonType.EDIT_EXCEPTIONAL_STORE_SCHEDULES]: {
    text: 'Modifier les horaires exceptionnel',
    endpoint: `/excepthours`,
  },
  [MiddleOfficeButtonType.EDIT_REALISATIONS]: {
    text: 'Editer les réalisations',
    endpoint: `/realisation/manage`,
  },
  [MiddleOfficeButtonType.ADD_REALISATION]: {
    text: 'Ajouter une réalisation',
    endpoint: `/realisation/create`,
  },
  [MiddleOfficeButtonType.EDIT_GALLERY]: {
    text: 'Modifier la galerie photo',
    endpoint: `/gallery`,
  },
};
